import Logger from 'loglevel'
// import Raven from 'raven'

Logger.setLevel(process.env.VUE_APP_LOG_LEVEL)

// TODO: setup Raven and logger handler
global.Logger = Logger

export default Logger
